module.exports = __webpack_public_path__ + "static/media/samplecampaign.512f3c42.csv";